module.exports = __webpack_public_path__ + "img/defaultProductIco.7328daa1.png";